import React from 'react';

const QuickSpinHeader = ({
  onUsage,
  onNew,
  onList,
  onSave,
  onShare,
  onFullscreen,
  isSaving,
  isSpinning,
  language = 'English',
}) => {
  return (
    <header className="flex items-center justify-between gap-2 px-3 py-2 bg-slate-900/90 border-b border-slate-700/60 text-sm">
      <div className="flex items-center gap-1 sm:gap-3 min-w-0">
        <span className="font-bold text-blue-400 tracking-tight text-base sm:text-lg whitespace-nowrap">
          QuickSpin
        </span>

        <nav className="hidden sm:flex items-center gap-1 text-slate-300">
          <button
            type="button"
            onClick={onUsage}
            className="px-2.5 py-1.5 rounded-md hover:bg-slate-800 transition"
            aria-label="Usage"
          >
            Usage
          </button>
          <button
            type="button"
            onClick={onNew}
            disabled={isSpinning}
            className="px-2.5 py-1.5 rounded-md hover:bg-slate-800 transition disabled:opacity-40"
            aria-label="New wheel"
          >
            New
          </button>
          <button
            type="button"
            onClick={onList}
            disabled
            className="px-2.5 py-1.5 rounded-md hover:bg-slate-800 transition"
            aria-label="List saved wheels"
          >
            List
          </button>
          <button
            type="button"
            onClick={onSave}
            // disabled={isSaving}
            disabled
            className="px-2.5 py-1.5 rounded-md hover:bg-slate-800 transition disabled:opacity-40 flex items-center gap-1"
            aria-label="Save wheel"
          >
            {isSaving ? 'Saving…' : 'Save'}
          </button>
          <button
            type="button"
            onClick={onShare}
            className="px-2.5 py-1.5 rounded-md hover:bg-slate-800 transition"
            aria-label="Share"
          >
            Share
          </button>
        </nav>
      </div>

      <div className="flex items-center gap-1 sm:gap-2">
        {/* Mobile menu buttons */}
        <div className="flex sm:hidden items-center gap-1">
          <button type="button" onClick={onList} className="p-2 rounded-md hover:bg-slate-800" aria-label="List">
            📋
          </button>
          <button type="button" onClick={onSave} disabled={isSaving} className="p-2 rounded-md hover:bg-slate-800 disabled:opacity-40" aria-label="Save">
            💾
          </button>
          <button type="button" onClick={onNew} disabled={isSpinning} className="p-2 rounded-md hover:bg-slate-800 disabled:opacity-40" aria-label="New">
            ✨
          </button>
        </div>

        <button
          type="button"
          onClick={onFullscreen}
          className="p-2 rounded-md hover:bg-slate-800 text-slate-300"
          aria-label="Toggle fullscreen"
        >
          ⛶
        </button>
        <button
          type="button"
          className="px-2.5 py-1.5 rounded-md hover:bg-slate-800 text-slate-300 flex items-center gap-1"
          aria-label="Language"
        >
          🌐 <span className="hidden sm:inline">{language}</span>
        </button>
      </div>
    </header>
  );
};

export default QuickSpinHeader;